import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NOTIFICATIONS = ['María de Córdoba compró el Kit Completo hace 3 minutos', 'Juan de Buenos Aires compró el Kit Completo hace 7 minutos', 'Lucía de Rosario compró el Kit Completo hace 12 minutos', 'Carlos de Mendoza compró el Kit Completo hace 15 minutos', 'Ana de Tucumán compró el Kit Completo hace 18 minutos', 'Pablo de Santa Fe compró el Kit Completo hace 22 minutos', 'Valentina de La Plata compró el Kit Completo hace 25 minutos', 'Diego de Salta compró el Kit Completo hace 30 minutos'];
export function SocialProofPopup() {
  const [currentNotification, setCurrentNotification] = useState<string | null>(null);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showRandomNotification();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showRandomNotification = () => {
    const randomIdx = Math.floor(Math.random() * NOTIFICATIONS.length);
    setCurrentNotification(NOTIFICATIONS[randomIdx]);
    // Hide after 4 seconds
    setTimeout(() => {
      setCurrentNotification(null);
      // Show next one after random interval 5-8s
      const nextDelay = Math.floor(Math.random() * 3000) + 5000;
      setTimeout(showRandomNotification, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-311">
      {currentNotification && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -20
    }} className="fixed bottom-4 left-4 z-40 max-w-xs md:max-w-sm bg-white border-l-4 border-[#22c55e] shadow-2xl rounded-r-lg p-4 flex items-start gap-3" data-id="element-312">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-313">
            <CheckCircle2 className="w-6 h-6 text-[#22c55e]" data-id="element-314" />
          </div>
          <div data-id="element-315">
            <p className="text-sm font-bold text-gray-900" data-id="element-316">
              ¡Nueva compra verificada!
            </p>
            <p className="text-sm text-gray-600 leading-tight mt-1" data-id="element-317">
              {currentNotification}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}